
import Vue from 'vue';

export default Vue.extend({
  name: "AboutPageCeo",
  data () {
    return {
      content: 'I believe trust is earned through consistency, precision, and the quality of every detail. My role is to ensure that each project is approached with clarity, aligned with real business goals, and delivered to the standard our clients expect.'
    }
  }
})
